import { createSlice } from '@reduxjs/toolkit';

import { type ISODateString } from '../../types/types';

interface ReportProductDataPayload {
  status: 'loading' | 'complete';
  brand: string;
  img: string;
  price: number;
  title: string;
  article: string;
  brandUrl: string;
  subjectId: number;
  subjectName: string;
  rating: number;
  note: string;
  description: string;
}
export interface ReportProductData extends ReportProductDataPayload {
  chart: Record<ISODateString, Record<string, number | null>>;
}

export interface SetProductDataAction {
  type: string;
  payload: ReportProductDataPayload;
}

export interface SetProductStatusAction {
  type: string;
  payload: ReportProductData['status'];
}

export interface SetProductChartAction {
  type: string;
  payload: ReportProductData['chart'];
}

const initialState: ReportProductData = {
  status: 'loading',
  brand: null,
  img: null,
  price: null,
  title: null,
  article: null,
  brandUrl: null,
  subjectId: null,
  subjectName: null,
  rating: null,
  note: null,
  description: null,
  chart: {},
};

export const reportProductSlice = createSlice({
  name: 'reportProductSlice',
  initialState,
  reducers: {
    setProductData: (state, action: SetProductDataAction) => ({
      ...state,
      ...action.payload,
    }),
    setProductStatus: (state, action: SetProductStatusAction) => ({
      ...state,
      status: action.payload,
    }),
    setProductChart: (state, action: SetProductChartAction) => {
      const ISODateStrings = Object.keys(action.payload);

      const chart = ISODateStrings.reduce((acc, date) => (
        {
          ...acc,
          [date]: {
            ...state.chart[date],
            ...action.payload[date],
          },
        }), {});

      state.chart = chart;
    },
    reset: () => initialState,
  },
});

export const { setProductData, setProductChart, reset } = reportProductSlice.actions;

export default reportProductSlice.reducer;
